<div class="feed-content" style="width: 100%; height: auto">
  @if (isSingleImage) {
    <feed-image
      id="{{index}}-feed"
      [feed]="feed.media[0]"
      (likeToggle)="updateLikes($event)"
      [isLiked]="isLiked"
      (click)="onSingleImageClick()">
    </feed-image>
  }
  @if (!isSingleImage) {
    <swiper [config]="carouselConfig" (swiper)="onSwiperInit($event)">
      @for (media of feed?.media; track media) {
        <ng-template swiperSlide="swiperSlide">
          @if (media?.type === appConfig.Shared.Feed.IMAGE) {
            <feed-image
              id="{{index}}-feed"
              [feed]="media"
              (likeToggle)="updateLikes($event)"
              [isLiked]="isLiked">
            </feed-image>
          }
          @if (media?.type === appConfig.Shared.Feed.VIDEO) {
            <feed-video
              id="{{index}}-feed"
              [feed]="media"
              (likeToggle)="updateLikes($event)"
              [isLiked]="isLiked"
              [visible]="feed?.isVisible"
              (onVideoPlay)="onVideoPlayWithTracking($event)"
              [index]="index">
            </feed-video>
          }
        </ng-template>
      }
    </swiper>
  }
</div>
<div class="feed-footer">
  <div class="caption">{{feed?.caption}}</div>
  <div class="tw-flex tw-justify-between tw-pt-2.5 tw-items-center">
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2">
      <!--    <img *ngIf="isNotIOSDevice" class="tw-h-5 tw-aspect-square" (click)="onShareClick()" src="/assets/icons/shareIconGray.svg" alt="like"/>-->
      <div class="tw-flex tw-justify-between tw-items-center tw-gap-1">
        @if (!isLiked) {
          <img class="tw-h-5 tw-aspect-square" (click)="onLikeClick()" src="/assets/icons/heartIconGray.svg" alt="like"/>
        }
        @if (isLiked) {
          <img class="tw-h-5 tw-aspect-square" (click)="onLikeClick()" src="/assets/icons/red-heart-explore.svg" alt="like"/>
        }
        <!--      <span class="tw-font-medium tw-font-body tw-text-gray-450 tw-text-200">{{feed?.likes}}</span>-->
      </div>
    </div>
    @if (feed.ctaText && !isCtaDisabled) {
      <div class="feed-btn" (click)="onCTAClick.emit(feed)">
        {{feed.ctaText}}
      </div>
    }
  </div>
</div>
